







































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import EventBus from '@/plugins/EventBus'
import { bytesToMegabytes } from '@/utils/common'
import SuportePaisesStore, { Pais } from '@/components/Suporte/Store/SuportePaisesStore'
import ModalSuportePais from '@/components/Suporte/components/ModalSuportePais.vue'
import { useHospitais } from '@/composables'

@Component({
  components: {
    ModalSuportePais,
  },
})
export default class ViewSuportePaises extends Vue {
  $refs!: {
    uploadJson: any,
    modalSuportePais: any,
  }

  fileUploadLimitInMegaBytes = 25
  loadExportPaises: boolean = false

  get getSuportePaisesStore() {
    return getModule(SuportePaisesStore, this.$store)
  }

  get loadingExportPaises() { return this.loadExportPaises }
  set loadingExportPaises(value: boolean) { this.loadExportPaises = value }
  get hospitalId() { return this.getSuportePaisesStore.hospitalId }
  set hospitalId(value: string) { this.getSuportePaisesStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get paisHeaders() {
    return [
      { text: 'Bandeira', align: 'left', value: 'isoCode', sortable: false },
      { text: 'Nome', align: 'left', value: 'nome', sortable: true },
      { text: 'ISO Code', align: 'center', value: 'isoCode', sortable: true },
      { text: 'DDI', align: 'center', value: 'ddi', sortable: false },
      { text: 'HisId', align: 'center', value: 'hisId', sortable: false },
      { text: 'Ações', align: 'center', value: '', sortable: false },
    ]
  }

  get searchPais() { return this.getSuportePaisesStore.searchPais }
  set searchPais(value: string) { this.getSuportePaisesStore.setSearchPais(value) }

  async hospitalChange(id: any) {
    this.getSuportePaisesStore.setHospitalId(id)
    await this.getSuportePaisesStore.getPaisAll()
  }

  async editarPais(item: any) {
    this.getSuportePaisesStore.setPais(item as Pais)
    this.$refs.modalSuportePais.$refs.paisForm.resetValidation()
    this.getSuportePaisesStore.setModal({ name: 'pais', value: true })
  }

  async inputFile(data: any) {
    const fileType: string = data.type
    if (fileType !== 'application/json') return
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando JSON...' })

    const fileSizeInMegabytes = bytesToMegabytes(data.file.size)
    if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
      EventBus.$emit('clearLoadingRequest')
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar arquivo. Limite máximo excedido.', icon: 'warning', color: '#C62828' })
      return
    }

    if (data.identifier) return
    const form = new FormData()
    form.append('form', data.file)
    this.getSuportePaisesStore.setPaisesJson(form)

    const request = await this.getSuportePaisesStore.importPaisJson()

    if (!request.success) {
      EventBus.$emit('clearLoadingRequest')
      EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      return
    }

    EventBus.$emit('clearLoadingRequest')
    EventBus.$emit('setSnackbar', { show: true, text: 'Paises importados com sucesso!', icon: 'check', color: '#2E7D32' })
  }

  async exportPaises() {
    this.loadingExportPaises = true
    const request = await this.getSuportePaisesStore.getPaisAll()
    if (request.success) {
      const data = JSON.stringify(this.getSuportePaisesStore.paises, null, 2)
      const blob = new Blob([data], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'paises.json'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    this.loadingExportPaises = false
  }

  beforeDestroy() {
    this.getSuportePaisesStore.clearSearchPais()
    this.getSuportePaisesStore.clearPaises()
    this.getSuportePaisesStore.clearPais()
    this.getSuportePaisesStore.clearHospitalId()
  }
}
